var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"bg-default-card no-padding"},[_c('b-tabs',{attrs:{"card":""}},[_c('b-tab',{attrs:{"title":_vm.uLang('app.candidates')}},[_c('client-trajectory-enrolments-tab',{attrs:{"apiUrl":_vm.route('relations.trajectory-enrolments.table', { relation: _vm.id })}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }